import { EMPTY_OBJECT } from '../../constants/common'

import { GROUP_CHAT_MIN_OTHER_PARTICIPANTS_COUNT } from './Chat.constants'

export function isChatUnread({
  unread_messages_count: unreadMessagesCount,
} = EMPTY_OBJECT) {
  return unreadMessagesCount > 0
}

export function getIsGroupChat(users) {
  return users?.length >= GROUP_CHAT_MIN_OTHER_PARTICIPANTS_COUNT
}
